import * as React from "react"
import { IconContext } from "react-icons"
import { Menu, Transition } from "@headlessui/react"
import { SlGlobe, SlArrowDown } from "react-icons/sl"
import { Link } from "gatsby"

export default function Language({ langs, locale }) {
  const uri = (string) => {
    let url = string.split("_")[0]
    if (url === "en") {
      url = ""
    }
    return "/" + url
  }

  const currentLocale = langs.find((v) => v.default_locale === locale)

  return (
    <Menu>
      <Menu.Button className="flex items-center gap-1 ml-auto text-[11px] leading-none group">
        <p>{currentLocale.translated_name}</p>
        <div className="flex items-center gap-1">
          <IconContext.Provider value={{ size: 12 }}>
            <SlGlobe />
          </IconContext.Provider>
          <div className="transition-transform group-hover:rotate-180">
            <IconContext.Provider value={{ size: 8 }}>
              <SlArrowDown />
            </IconContext.Provider>
          </div>
        </div>
      </Menu.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items className="absolute right-0 z-50 px-4 py-2 mt-2 space-y-2 text-sm text-right bg-white shadow-lg top-full rounded-xl text-dark">
          {langs.map((item) => {
            // Hiding ID and ZH
            if (item.code === "id" || item.code === "zh") {
              return null
            }

            return (
              <Menu.Item key={item.default_locale} className="block">
                {({ active }) => (
                  <Link to={uri(item.default_locale)}>
                    {item.translated_name}
                  </Link>
                )}
              </Menu.Item>
            )
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
